import React from "react";
import PropTypes from "prop-types";
import { Card, Table, Typography, Avatar, Tooltip } from "antd";
import { BarChartOutlined, UserOutlined } from "@ant-design/icons";
import { baseImageUrl } from "Common/Components/baseImageUrl";
import { useContext } from "react";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
const { Text } = Typography;
const PerformanceTable = ({ styles, learners }) => {
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = !isProfileComplete;
  const handleTableClick = () => {
    if (isBlocked) return;
    // Table click logic if needed
  };
  const handleRowClick = (record) => {
    if (isBlocked) return;
    console.log('Row clicked:', record);
  };
  const columns = [
    {
      title: "Learner",
      dataIndex: "profileImage",
      key: "profileImage",
      render: (_, record) => (
        <Tooltip title={isBlocked ? "Complete your profile to access this feature" : ""}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              cursor: isBlocked ? 'not-allowed' : 'pointer'
            }}
            onClick={() => handleRowClick(record)}
          >
            <Avatar
              src={record.profileImage ? `${baseImageUrl}${record.profileImage}` : null}
              icon={!record.profileImage && <UserOutlined />}
              size="large"
              style={{
                backgroundColor: record.profileImage ? "transparent" : "#B17F14",
              }}
            />
            <Text strong style={{ opacity: isBlocked ? 0.6 : 1 }}>
              {record.firstName} {record.lastName}
            </Text>
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Trainings",
      dataIndex: "trainings",
      key: "trainings",
      render: (trainings) => (
        <Text style={{ opacity: isBlocked ? 0.6 : 1 }}>
          {Array.isArray(trainings) ? trainings.join(", ") : "-"}
        </Text>
      ),
    },
  ];
  return (
    <Tooltip title={isBlocked ? "Complete your profile to access this feature" : ""}>
      <Card
        title={
          <span style={{ ...styles.cardTitle, opacity: isBlocked ? 0.6 : 1 }}>
            <BarChartOutlined style={{ marginRight: 8 }} /> Performance Metrics
          </span>
        }
        hoverable
        style={{
          ...styles.card,
          cursor: isBlocked ? 'not-allowed' : 'default',
          opacity: isBlocked ? 0.6 : 1
        }}
        onClick={handleTableClick}
      >
        <Table
          columns={columns}
          dataSource={learners}
          scroll={{ x: "max-content" }}
          pagination={{ pageSize: 5 }}
          style={{
            marginTop: 16,
            opacity: isBlocked ? 0.6 : 1
          }}
          rowKey="learnerId"
          onRow={(record) => ({
            onClick: () => handleRowClick(record),
            style: {
              cursor: isBlocked ? 'not-allowed' : 'pointer',
            }
          })}
        />
      </Card>
    </Tooltip>
  );
};
PerformanceTable.propTypes = {
  styles: PropTypes.shape({
    card: PropTypes.object,
    cardTitle: PropTypes.object,
  }).isRequired,
  learners: PropTypes.arrayOf(
    PropTypes.shape({
      learnerId: PropTypes.number.isRequired,
      userId: PropTypes.number,
      email: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      phoneNo: PropTypes.string,
      profileImage: PropTypes.string,
      isManagerAssigned: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
      managerAssignedDate: PropTypes.string,
      managerId: PropTypes.number,
      createdOn: PropTypes.string,
      lastModifiedOn: PropTypes.string,
    })
  ).isRequired,
};
export default PerformanceTable;